import EnlilAxios from "../../../../util/EnlilAxios";
import {V1BillConfigurationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class BillConfigurationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/bill_configurations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.BillConfiguration-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1BillConfigurationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.BillConfiguration-001";
        payload.ShifamedMessage.BillConfiguration = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/bill_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.BillConfiguration-001",
                "idoc-response": "v1.BillConfiguration-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1BillConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let billConfiguration = {};

        billConfiguration["USID"] = this.getAttributeValue("USID");
        billConfiguration["UserName"] = this.getAttributeValue("UserName");
        billConfiguration["Password"] = this.getAttributeValue("Password");
        billConfiguration["OrganizationID"] = this.getAttributeValue("OrganizationID");
        billConfiguration["DeveloperKey"] = this.getAttributeValue("DeveloperKey");
        billConfiguration["V3APIUrl"] = this.getAttributeValue("V3APIUrl");
        billConfiguration["V2APIUrl"] = this.getAttributeValue("V2APIUrl");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.BillConfiguration-001";
        payload.ShifamedMessage.BillConfiguration = billConfiguration;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/bill_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1BillConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default BillConfigurationEnterpriseComponent;